import { RJSFSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/core";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import MultidimensionalCustomFormTemplate from "../templates/MultidimensionalCustomFormTemplate";
import { ChangeDectionContext } from "../context/ChangeDectionContext";
import useProcessUiSchema from "../hooks/useProcessUiSchema";

interface Prop {
  modelConfig: any;
  formConfig: {
    formRef: any;
    onSubmit: any;
    contextInstance: any;
    filterData?: any;
  };
}

function BeelditGenericForm(props: Prop) {
  const { formRef, onSubmit, contextInstance, filterData } = props.formConfig;
  const {
    formSchema,
    editFormSchema,
    uiFormSchema,
    formWidgets,
    disabledInEdition,
  } = props.modelConfig;
  const { element, setElement, backendFormErrors } = contextInstance;
  const debugMode = process.env.REACT_APP_DEBUG_MODE;

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});
  const [uiFinalSchema, setUiFinalSchema] = useState<RJSFSchema>({});

  const customWidgets = { ...widgets, ...formWidgets };
  const handleChange = (type: any) => {
    setChanged(true, type.formData);
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();
  const processUiSchemaFunction = useProcessUiSchema();

  useEffect(() => {
    let selectedFormSchema =
      element && element.id && editFormSchema ? editFormSchema : formSchema;

    // Debounce para evitar procesar schema en cada pulsación/pequeño cambio
    const debounceMs = 100;
    const timer = window.setTimeout(() => {
      const newSchema = processSchemaFunction(selectedFormSchema, element);
      setFinalSchema(newSchema);
      const newUiSchema = processUiSchemaFunction(uiFormSchema, element, filterData);
      setUiFinalSchema(newUiSchema);
    }, debounceMs);

    return () => {
      clearTimeout(timer);
    };
  }, [element, formSchema, editFormSchema, uiFormSchema, filterData, processSchemaFunction, processUiSchemaFunction]);

  const formTemplate = MultidimensionalCustomFormTemplate;

  const templates = uiFormSchema?.colsSchema
    ? {
        ObjectFieldTemplate: formTemplate,
      }
    : {};

  const { changed, setChanged } = useContext(ChangeDectionContext);

  return (
    <>
      {/* {
      element && (<>{JSON.stringify(element)}</>)      
    } */}
      <JSONSchemaForm
        noHtml5Validate
        showErrorList={false}
        ref={formRef}
        templates={templates}
        schema={finalSchema}
        uiSchema={uiFinalSchema}
        widgets={customWidgets}
        formData={element}
        formContext={contextInstance}
        validator={validator}
        onChange={handleChange}
        onSubmit={onSubmit}
        onError={log("errors")}
        extraErrors={backendFormErrors}
        disabled={disabledInEdition && element && element.id ? true : false}
      />
    </>
  );
}

export default BeelditGenericForm;
